<template>
   <v-container fluid> 
    <!-- Dialogs -->
       <FileImportDialog>
           <template v-slot:importOptions>
                <v-row justify="center">
                    <v-col cols="3">                         
                        <v-select
                            v-model="selectedYear"
                            :items="yearOptions"
                            :label="$t('lang_PUBLISHING_TRACKING_PROLISTS_PANEL_CAPTION_YEAR')"
                            hide-details                        
                        ></v-select>                            
                    </v-col>
                </v-row>
           </template>
       </FileImportDialog>
       <!-- <DeletionDialog context="Prolists" />  
       <DeletionDialog context="MyMapping" />   -->
    <!-- Headline -->
        <v-row>
            <v-col class="headline">{{ $t('lang_PUBLISHING_TRACKING') }}</v-col>
        </v-row>   
    <!-- Panels -->
        <v-expansion-panels
            multiple 
            focusable  
            tile  
            flat 
        >            
            <ProlistsPanel />                           
            <SetlistsPanel />
            <MyMappingPanel />
        </v-expansion-panels>
    </v-container>        
</template>

<script>
import ProlistsPanel from './_panels/1_prolists/ProlistsPanel'
import SetlistsPanel from './_panels/3_setlists/SetlistsPanel'
import MyMappingPanel from './_panels/4_mapping/MyMappingPanel'
// import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import FileImportDialog from '@/components/_dialogs/FileImportDialog'

export default {
    name: "Tracking",
    components: {
        ProlistsPanel,
        SetlistsPanel,
        MyMappingPanel,
        // DeletionDialog,
        FileImportDialog
    },
    computed: {
        selectedYear: {
            get() { return this.$store.getters.getSelectedUploadYear },
            set(year) { this.$store.commit('setSelectedUploadYear', year)}
        }, 

        yearOptions() {
            let years = []  
            let maxYear = new Date().getFullYear()
            for(let i = maxYear; i >= 2008; i--) years.push(i) 
            return years              
        }
    }
}
</script>